/**
 * Rate-card metering-provider custom field `access_scope`.
 * Marks which contract drives system access / dunning.
 */
export enum AccessScopeEnum {
  SYSTEM = 'system',
}
